import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import { getSocialMediaLinkValue } from '../../services/apps/AccountService';
import { userHasMemberRole } from '../../services/apps/side-menu-builders/SideMenuHelper';

class BrandingDataDetail extends Component {
  render() {
    const {
      account, toggleEdit, role,
    } = this.props;
    const { socialMediaLinks } = account.brandingInformation;

    const linkedInValue = getSocialMediaLinkValue(socialMediaLinks, 'linkedin');

    const facebookValue = getSocialMediaLinkValue(socialMediaLinks, 'facebook');

    const twitterValue = getSocialMediaLinkValue(socialMediaLinks, 'twitter');

    const googlePlusValue = getSocialMediaLinkValue(socialMediaLinks, 'googleplus');

    const pencilIcon = 'fa fa-pencil';
    const hasPermissionToEdit = !userHasMemberRole(role);

    return (
      <div>
        <Panel header={(
          <div className="p-grid p-nogutter">
            <div className="p-col">
              <FormattedMessage id="settings.brandingDetails" defaultMessage="Branding details" />
            </div>
            <div className="p-col-2 align-right">
              {
                hasPermissionToEdit
                && (
                  <Button
                    icon={pencilIcon}
                    type="button"
                    className="p-button-secondary p-button-sm"
                    onClick={toggleEdit}
                  />
                )
              }
            </div>
          </div>
        )}
        >
          <div>
            <FormattedMessage
              id="settings.branding-data.website"
              defaultMessage="Website: "
              tagName="strong"
            />
            <div>
              <a href={account.brandingInformation.website}>
                {account.brandingInformation.website}
              </a>
            </div>
          </div>
          <br />
          <div>
            <FormattedMessage
              id="settings.branding-data.linkedin"
              defaultMessage="LinkedIn: "
              tagName="strong"
            />
            <div>
              <a href={linkedInValue}>
                {linkedInValue}
              </a>
            </div>
          </div>
          <br />
          <div>
            <FormattedMessage
              id="settings.branding-data.facebook"
              defaultMessage="Facebook: "
              tagName="strong"
            />
            <div>
              <a href={facebookValue}>
                {facebookValue}
              </a>
            </div>
          </div>
          <br />
          <div>
            <FormattedMessage
              id="settings.branding-data.twitter"
              defaultMessage="Twitter: "
              tagName="strong"
            />
            <div>
              <a href={twitterValue}>
                {twitterValue}
              </a>
            </div>
          </div>
          <br />
          <div>
            <FormattedMessage
              id="settings.branding-data.googleplus"
              defaultMessage="Google Plus: "
              tagName="strong"
            />
            <div>
              <a href={googlePlusValue}>
                {googlePlusValue}
              </a>
            </div>
          </div>
          <br />
        </Panel>
      </div>
    );
  }
}

BrandingDataDetail.propTypes = {
  account: PropTypes.objectOf(PropTypes.any).isRequired,
  role: PropTypes.string.isRequired,
  toggleEdit: PropTypes.func.isRequired,
};

export default BrandingDataDetail;
